import second_image from '../img/trameco.png';

export default function LogoSecond({style = "h-8"}) {
  return (
    <img class={style+" w-auto"} src={second_image} alt="Also us"/>
  )
}